/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Col_LocationInputs */

const cs_documents_col_location = /** @type {(inputs: Documents_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umístění`)
};

const en_documents_col_location = /** @type {(inputs: Documents_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Documents_Col_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_location = /** @type {((inputs?: Documents_Col_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_col_location(inputs)
	return cs_documents_col_location(inputs)
});